import React from "react";

import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import LPPEditorNavigator from "../../components/editors/lpp/LPPEditorNavigator";
import { useAtomValue } from "jotai";
import { editLppPlanCallback } from "../../atoms/core";

type LPPEditorNavScreenProps = StackScreenProps<RootStackParamList, "LPPEditorNavScreen">;

const LPPEditorNavScreen: React.FC<LPPEditorNavScreenProps> = ({ route }) => {
    const { lppPlan, cct, availablePlans, useLse } = route.params;
    const callback = useAtomValue(editLppPlanCallback);
    return (
        <LPPEditorNavigator
            lppPlan={lppPlan}
            cct={cct}
            useLse={useLse}
            availablePlans={availablePlans}
            onSave={callback.func}
        />
    );
};

export default LPPEditorNavScreen;
